import React from "react";
import { GridCellProps } from "@progress/kendo-react-grid";
import { getScoreStyle } from "../utils/scoreColors";

const ScoreCell: React.FC<GridCellProps> = (props) => {
  const value = props.dataItem[props.field ?? ""];
  const style = getScoreStyle(value);

  // Dark themes force grid td text to the body colour with !important (App.css), which
  // overrides the td style. "Flagged" carries its colour on a span so it stays red in every theme.
  return (
    <td style={style}>
      {value === "Flagged" ? <span style={style}>{value}</span> : value || ""}
    </td>
  );
};

export default ScoreCell;
